export default __webpack_public_path__ + "static/media/bg.03d91d74.png";